import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { MultiSelect as MultiSelectDS } from '@jisr-hr/design-system'

const MultiSelect = ({
  meta: { error, touched },
  input: { onChange, value, onBlur },
  options,
  valueKey,
  labelKey,
  nestedValue,
  disabled,
  testId,
  ...rest
}) => {
  const [selectValues, setSelectValues] = React.useState([])
  function getSelected(data = [], slected = []) {
    const newSlected = []

    // in some caese return empty string and its cuse crash app
    // better to return empty array in first
    if (isEmpty(slected)) return []

    if (nestedValue && !isEmpty(slected)) {
      const filtered = data.filter((d) => {
        const slectedIds = slected.map((s) => s[nestedValue])
        return slectedIds.includes(d[valueKey])
      })
      return filtered
    }

    data.map((d) => {
      if (slected.includes(d[valueKey])) {
        newSlected.push(d)
      }
      return null
    })
    return newSlected
  }

  function handleOnChange(data = []) {
    let newData = []
    onBlur()
    // const ids = data && data.map(val => val[valueKey]);
    if (isEmpty(data)) return onChange([])

    if (nestedValue) {
      newData = data.map((val) => ({
        [nestedValue]: val[valueKey],
      }))
    } else {
      newData = data.map((val) => val[valueKey])
    }

    return onChange(newData)
  }

  React.useEffect(() => {
    const selected = getSelected(options, value)
    setSelectValues(selected)
  }, [value, options])

  return (
    <MultiSelectDS
      status={error && touched && 'error'}
      statusMessage={error}
      {...rest}
      isMulti
      options={options}
      onChange={handleOnChange}
      getOptionLabel={(data) => data && data[labelKey]}
      getOptionValue={(data) => data && data[valueKey]}
      value={selectValues}
      isDisabled={disabled}
      data-testid={testId}
    />
  )
}

MultiSelect.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape()),
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  nestedValue: PropTypes.string,
  testId: PropTypes.string,
  disabled: PropTypes.bool,
}

export default React.memo(MultiSelect)
